import { CheckCircle2 } from 'lucide-react';

import { useT } from '../../../i18n';
import { TRANG_THAI_PHIEN_BAN } from '../constants';
import type { ModulePackageResult } from '../types';

/**
 * Kết quả nộp gói thành công (`ModulePackageResult`, ADR-0045 mục 1) — chỉ
 * hiện ngay sau lần nộp vừa rồi. API không lưu lại "kết quả kiểm" để xem lại
 * sau; khi nộp lỗi, `LoiTrongHop` hiện `error_code` qua `MA_LOI_NOP_GOI`
 * (`constants.ts`) ngay dưới khu vực upload thay cho khối này.
 */
export function KetQuaNopGoi({ ketQua }: { ketQua: ModulePackageResult }) {
  const { t } = useT();
  return (
    <div className="flex items-start gap-2 rounded border border-success-200 bg-success-50 px-3 py-2.5">
      <CheckCircle2 size={15} className="mt-0.5 shrink-0 text-success-600" />
      <div className="min-w-0 text-xs leading-relaxed text-success-700">
        <p className="font-medium">
          {t('quanLyModule.upload.ketQua', { code: ketQua.code, phienBan: ketQua.version })}
        </p>
        <p className="text-success-600">{t(TRANG_THAI_PHIEN_BAN[ketQua.status].khoa)}</p>
      </div>
    </div>
  );
}
